import { render, staticRenderFns } from "./TreeChart.vue?vue&type=template&id=5ffdca83&scoped=true&"
import script from "./TreeChart.vue?vue&type=script&lang=js&"
export * from "./TreeChart.vue?vue&type=script&lang=js&"
import style0 from "./TreeChart.vue?vue&type=style&index=0&id=5ffdca83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffdca83",
  null
  
)

export default component.exports